export class ActivePlaylists {
    DownloadCompleteDate: string;
    PlaylistId: string;
    PlaylistName: string;
}